// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#HeightProfile {
    display: flex;
    align-items: flex-end;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 2.25em;
    background-color: rgba(255, 255, 255, 0.80);
    box-shadow: 0 -2px 4px rgba(136, 136, 136, 0.5);
    padding-top: 0.5em;
    z-index: 2;
}

#HeightProfile g.ct-grids line.ct-grid {
    stroke: lightgray;
    stroke-width: 1px;
}

#HeightProfile g.ct-series-a path.ct-line {
    stroke: red;
    stroke-width: 2px;
    fill: none;
}

#HeightProfile g.ct-series-a path.ct-area {
    fill: rgba(255,0,0,0.5);
}

#HeightProfile g.ct-labels .ct-label {
    color: gray;
    fill: gray;
    text-anchor: middle;
    font-size: 0.75rem;
    display: flex;
}

#HeightProfile g.ct-labels span.ct-vertical {
    justify-content: flex-end;
    align-items: center;
    transform: translate(0, 50%);
}

#HeightProfile g.ct-labels span.ct-horizontal {
    justify-content: center;
    transform: translate(-50%,0);
}

#HeightProfile text.ct-axis-title {
    fill: gray;
    font-size: 0.8rem;
}

#HeightProfile span.height-profile-tooltip {
    visibility: hidden;
    position: absolute;
    display: inline-block;
    background-color: var(--tooltip-bg-color);
    border: 1px solid var(--tooltip-border-color);
    border-radius: 0.5em;
    padding: 0.5em;
    color: var(--tooltip-text-color);
    transform: translate(-50%, 0%);
    white-space: nowrap;
    font-size: 90%;;
}

#HeightProfile span.height-profile-marker {
    visibility: hidden;
    position: absolute;
    display: inline-block;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.5);
    pointer-events: none;
}

#HeightProfile div.height-profile-loading-indicator {
    display: flex;
    align-items: center;
    padding-left: 0.5em;
    padding-bottom: 0.5em;
}

#HeightProfile div.height-profile-loading-indicator > div.spinner {
    width: 1.5em;
    height: 1.5em;
    margin-right: 0.25em;
}

#HeightProfile span.export-profile-button {
    cursor: pointer;
    font-size: large;
    margin-bottom: 0.25em;
}
`, "",{"version":3,"sources":["webpack://./qwc2/plugins/style/HeightProfile.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,OAAO;IACP,QAAQ;IACR,cAAc;IACd,2CAA2C;IAC3C,+CAA+C;IAC/C,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,yCAAyC;IACzC,6CAA6C;IAC7C,oBAAoB;IACpB,cAAc;IACd,gCAAgC;IAChC,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB","sourcesContent":["#HeightProfile {\n    display: flex;\n    align-items: flex-end;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 2.25em;\n    background-color: rgba(255, 255, 255, 0.80);\n    box-shadow: 0 -2px 4px rgba(136, 136, 136, 0.5);\n    padding-top: 0.5em;\n    z-index: 2;\n}\n\n#HeightProfile g.ct-grids line.ct-grid {\n    stroke: lightgray;\n    stroke-width: 1px;\n}\n\n#HeightProfile g.ct-series-a path.ct-line {\n    stroke: red;\n    stroke-width: 2px;\n    fill: none;\n}\n\n#HeightProfile g.ct-series-a path.ct-area {\n    fill: rgba(255,0,0,0.5);\n}\n\n#HeightProfile g.ct-labels .ct-label {\n    color: gray;\n    fill: gray;\n    text-anchor: middle;\n    font-size: 0.75rem;\n    display: flex;\n}\n\n#HeightProfile g.ct-labels span.ct-vertical {\n    justify-content: flex-end;\n    align-items: center;\n    transform: translate(0, 50%);\n}\n\n#HeightProfile g.ct-labels span.ct-horizontal {\n    justify-content: center;\n    transform: translate(-50%,0);\n}\n\n#HeightProfile text.ct-axis-title {\n    fill: gray;\n    font-size: 0.8rem;\n}\n\n#HeightProfile span.height-profile-tooltip {\n    visibility: hidden;\n    position: absolute;\n    display: inline-block;\n    background-color: var(--tooltip-bg-color);\n    border: 1px solid var(--tooltip-border-color);\n    border-radius: 0.5em;\n    padding: 0.5em;\n    color: var(--tooltip-text-color);\n    transform: translate(-50%, 0%);\n    white-space: nowrap;\n    font-size: 90%;;\n}\n\n#HeightProfile span.height-profile-marker {\n    visibility: hidden;\n    position: absolute;\n    display: inline-block;\n    width: 1px;\n    background-color: rgba(0, 0, 0, 0.5);\n    pointer-events: none;\n}\n\n#HeightProfile div.height-profile-loading-indicator {\n    display: flex;\n    align-items: center;\n    padding-left: 0.5em;\n    padding-bottom: 0.5em;\n}\n\n#HeightProfile div.height-profile-loading-indicator > div.spinner {\n    width: 1.5em;\n    height: 1.5em;\n    margin-right: 0.25em;\n}\n\n#HeightProfile span.export-profile-button {\n    cursor: pointer;\n    font-size: large;\n    margin-bottom: 0.25em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
